import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const note = (order) => {
  if (order.delivered_email_sent_at) return "Il cliente ha già ricevuto l'email di ringraziamento: non ne invieremo un'altra.";
  if (!order.customer_email) return "Questo ordine non ha un indirizzo email: nessuna email verrà inviata.";
  return `Invieremo a ${order.customer_email} un breve grazie con il link per riordinare gli stessi prodotti.`;
};

export const DeliverDialog = ({ order, open, onOpenChange, onConfirm, saving }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="w-[calc(100%-2rem)] max-w-md rounded-3xl border-copper/20 bg-cream p-7 sm:p-8" data-testid="deliver-dialog">
      <AlertDialogTitle className="font-display text-3xl font-medium text-navy">
        Ordine {order.session_id.slice(-8).toUpperCase()} consegnato?
      </AlertDialogTitle>
      <AlertDialogDescription className="text-[15px] leading-relaxed text-slate2" data-testid="deliver-dialog-note">{note(order)}</AlertDialogDescription>
      <div className="mt-2 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
        <AlertDialogCancel data-testid="deliver-cancel" className="mt-0 h-12 rounded-full border-navy/20 px-6 text-[15px] text-navy">Annulla</AlertDialogCancel>
        <AlertDialogAction
          disabled={saving}
          onClick={(e) => {
            e.preventDefault();
            onConfirm({ status: "delivered" });
          }}
          data-testid="deliver-confirm"
          className="h-12 rounded-full bg-navy px-6 text-[15px] font-medium text-ivory hover:bg-navy-700"
        >
          {saving ? "Salvo…" : "Segna come consegnato"}
        </AlertDialogAction>
      </div>
    </AlertDialogContent>
  </AlertDialog>
);
